export type TabTargetMode = 'merged' | 'legacy';

type RouteParams = Record<string, string | number | undefined>;

type RouteTarget = {
  pathname: string;
  params?: RouteParams;
};

const withOptionalParams = (pathname: string, params?: RouteParams): RouteTarget =>
  params ? { pathname, params } : { pathname };

export const getDocumentsTabTarget = (
  mode: TabTargetMode = 'merged',
  params?: RouteParams,
): RouteTarget =>
  mode === 'legacy'
    ? withOptionalParams('/(tabs)/documents', params)
    : withOptionalParams('/(tabs)/more', { tab: 'documents', ...params });

export const getProfileTabTarget = (
  mode: TabTargetMode = 'merged',
  params?: RouteParams,
): RouteTarget =>
  mode === 'legacy'
    ? withOptionalParams('/(tabs)/profile', params)
    : withOptionalParams('/(tabs)/more', { tab: 'profile', ...params });

export const getMapsTabTarget = (
  mode: TabTargetMode = 'merged',
  params?: RouteParams,
): RouteTarget =>
  mode === 'legacy'
    ? withOptionalParams('/(tabs)/maps', params)
    : withOptionalParams('/(tabs)/travel', { tab: 'maps', ...params });

export const getSafetyTabTarget = (
  mode: TabTargetMode = 'merged',
  params?: RouteParams,
): RouteTarget =>
  mode === 'legacy'
    ? withOptionalParams('/(tabs)/safety', params)
    : withOptionalParams('/(tabs)/travel', { tab: 'safety', ...params });
